import { defineStore } from 'pinia'
import type { Plan } from '~/types'

export const usePlanStore = defineStore('plan', {
    state: () => ({
        plans: [] as Plan[],
        upgradeLink: null as string | null,
    }),

    actions: {

        async setUpgradeLink() {
            const workspaceStore = useWorkspaceStore();
            if (workspaceStore.features?.billing?.has_subscription) {
                this.upgradeLink = `/settings/billing/change-plan`;
            } else {
                this.upgradeLink = `/settings/billing/subscribe`;
            }
        },

        async fetchPlans() {
            const { $api } = useNuxtApp();
            await $api.get("/plans")
                .then((response) => {
                    this.plans = response.data;

                    this.setUpgradeLink();
                }).catch((error) => {
                    console.error(error);
                })
        },
        clear() {
            this.plans = []
        }
    }
})